import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/shared/PageHero";
import api from "@/lib/api";

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHero
        label="Product Categories"
        title="Wholesale ranges across every segment."
        subtitle="Explore our organized wholesale portfolio — from premium men's wear to trending kids collections and complementary accessories."
        breadcrumbs={[{ label: "Categories" }]}
      />
      <section className="py-14">
        <div className="mx-auto max-w-7xl px-4 md:px-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          {cats.map((c, i) => (
            <motion.div
              key={c.id}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
            >
              <Link to={`/products?category=${encodeURIComponent(c.name)}`} className="group block relative overflow-hidden rounded-md border border-border/60 hover:border-gold/60 transition-colors">
                <div className="aspect-[16/10] md:aspect-[16/9] overflow-hidden bg-secondary">
                  {c.image && <img src={c.image} alt={c.name} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-7">
                  <p className="section-label text-gold mb-2">Wholesale Range</p>
                  <h2 className="font-serif text-3xl md:text-4xl text-white">{c.name}</h2>
                  <p className="mt-3 text-white/75 text-sm max-w-md">{c.description}</p>
                  <p className="mt-5 inline-flex items-center gap-2 text-white text-xs tracking-widest uppercase">
                    Explore Range <ArrowRight size={13} className="transition-transform group-hover:translate-x-1" />
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
